import routes from '@config/routes.json';

import { INavbarItem, NavbarItemTypes, ScreenTypes } from '.';

export const authNavItems: { [key: string]: INavbarItem[] } = {
    advertiser: [
        {
            type: NavbarItemTypes.link,
            key: 'Campaigns',
            id: 'NavbarCampaigns',
            label: 'Campaigns',
            screen: ScreenTypes.always,
            href: routes.campaigns,
        },
        {
            type: NavbarItemTypes.link,
            key: 'Bloggers',
            label: 'Bloggers',
            id: 'NavBarBloggers',
            screen: ScreenTypes.always,
            href: routes.bloggers,
        },
        {
            type: NavbarItemTypes.link,
            key: 'Integrations',
            screen: ScreenTypes.always,
            id: 'NavBarDesktopIntegrationsDropdown',
            label: 'Integrations',
            href: routes.integrations.list,
        },
        {
            type: NavbarItemTypes.link,
            key: 'Placements',
            label: 'Placements',
            id: 'NavBarPlacements',
            screen: ScreenTypes.always,
            href: routes.placements.list,
        },
        {
            type: NavbarItemTypes.link,
            key: 'Finance',
            label: 'Finance',
            id: 'NavBarDashboard',
            screen: ScreenTypes.always,
            href: routes.dashboard,
        },
    ],
    blogger: [
        {
            type: NavbarItemTypes.link,
            key: 'Integrations',
            screen: ScreenTypes.always,
            id: 'NavBarDesktopIntegrationsDropdown',
            label: 'Integrations',
            href: routes.integrations.list,
        },
        {
            type: NavbarItemTypes.link,
            key: 'My Traffic Sources',
            label: 'My Traffic Sources',
            id: 'NavBarDesktopTrafficSourcesLink',
            screen: ScreenTypes.always,
            href: routes.placements.list,
        },
    ],
};

export const notAuthNavItems: INavbarItem[] = [];
